import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import CustomInput from '../../../../components/CustomInput/CustomInput';
import { StyledAccordion, StyledAccordionDetails, StyledAccordionSummary, StyledTableContainer, TypographySecondary } from './styled';

interface Props {
    expanded: boolean;
    description: string;
    completed: boolean;
    onChange: () => void;
    section: any;
    baseInputPropsTemplate: any;
    baseInputPropsTranslation: any;
    fixedtopmargin: boolean;
}

const TranslationAccordion = (props: Props) => {
    const { expanded, description, completed, onChange, section, baseInputPropsTemplate, baseInputPropsTranslation, fixedtopmargin } = props;
    const { name, keys } = section;

    return (
        <StyledAccordion expanded={expanded} onChange={onChange} fixedtopmargin={fixedtopmargin ? 1 : 0} >
            <StyledAccordionSummary expandIcon={<ExpandMoreIcon />} completed={completed ? 1 : 0} >
                <Typography>{name}</Typography>
                <TypographySecondary>{description}</TypographySecondary>
            </StyledAccordionSummary>

            <StyledAccordionDetails>
                {expanded && (
                    <StyledTableContainer className='book-list-table-view' key={name} >
                        <Table>
                            {keys.map((key: string) => {
                                return (
                                    <TableRow key={key}>
                                        <TableCell>
                                            <CustomInput {...baseInputPropsTemplate} name={key} />
                                        </TableCell>
                                        <TableCell>
                                            <CustomInput {...baseInputPropsTranslation} name={key} />
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </Table>
                    </StyledTableContainer>
                )}
            </StyledAccordionDetails>
        </StyledAccordion>
  );
};

export default TranslationAccordion;
